import { colors } from '../../Colors/colors'

export const renameBoardTheme = {
   light: {
      renameBoard: {
         boardHeading: 'text-gray-900',
         description: 'text-gray-600',
         closeIconColor: colors['gray-500']
      }
   },
   dark: {}
}
